/* AP — ülke+dil seçici: bayrağa tıklayınca liste açılır; bir seçeneğe tıklayınca ülke + dil birlikte gönderilir. */
(function () {
  'use strict';
  if (window.__apUd) { return; }
  window.__apUd = true;
  function kapat(d) { var b = d.querySelector('[data-ap-ud-btn]'), l = d.querySelector('.ap-ud__list'); if (b) { b.setAttribute('aria-expanded', 'false'); } if (l && d.getAttribute('data-mod') === 'acilir') { l.hidden = true; } }
  function ac(d) { var b = d.querySelector('[data-ap-ud-btn]'), l = d.querySelector('.ap-ud__list'); if (b) { b.setAttribute('aria-expanded', 'true'); } if (l) { l.hidden = false; } }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ap-ud-btn]');
    var opt = e.target.closest && e.target.closest('.ap-ud__opt');
    var tum = document.querySelectorAll('[data-ap-ud]');
    if (btn) {
      var d = btn.closest('[data-ap-ud]'), acik = btn.getAttribute('aria-expanded') === 'true';
      Array.prototype.forEach.call(tum, kapat);
      if (!acik) { ac(d); }
      return;
    }
    if (opt) {
      var kap = opt.closest('[data-ap-ud]'), f = kap.querySelector('form');
      if (opt.classList.contains('ap-ud__opt--aktif')) { kapat(kap); return; }
      kap.querySelector('[data-ap-ud-c]').value = opt.getAttribute('data-c');
      kap.querySelector('[data-ap-ud-l]').value = opt.getAttribute('data-l');
      f.submit();
      return;
    }
    Array.prototype.forEach.call(tum, function (d) { if (!d.contains(e.target)) { kapat(d); } });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { Array.prototype.forEach.call(document.querySelectorAll('[data-ap-ud]'), kapat); } });
})();
